/* eslint-disable no-unused-vars */
/* global G */
import { curry, setKey } from 'lib/util'
import sequenceComponentFindProxy from 'lib/sequence/component/children/find'

/**
 * Reloads the list denoted by `target`
 *
 * @param {string} target                     key of the list
 * @param {Gaia.AppModule.Spec} module        app module
 * @param {Gaia.Component.Spec} component     action component
 * @param {Gaia.AppModule.EventHandler} event event
 */
const reloadList = (target, module, component, event) => {
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]

  const { [target]: listComponent } = sequenceComponentFindProxy(actionComponent)

  listComponent && setKey({}, 'reload', listComponent[G.STATE])
}

export default curry(reloadList)
